import Rete from 'rete'

import CONST_SOCKET from '../../const/socket'
import lingualName from '../../const/lingualName'
import CONST_COMPONENT from '../../const/component'
import UserInputFlowSingleTemplate from './UserInputFlowSingleTemplate'
import { lang } from '../../assets/lang'

const instagram_addon = window.xitFlowBuilderData.instagram_addon
var recurring_notification_addon = window.xitFlowBuilderData.recurring_notification_addon
var instagram_recurring_notification_addon = window.xitFlowBuilderData.instagram_recurring_notification_addon

var recurring_notification_display = 0;
if(!instagram_addon && recurring_notification_addon)
  recurring_notification_display = 1;
if(instagram_addon && instagram_recurring_notification_addon)
  recurring_notification_display = 1;

export default class UserInputFlowSingleComponent extends Rete.Component {
  constructor(config) {
    super(CONST_COMPONENT.USER_INPUT_FLOW_SINGLE)

    this.data.component = UserInputFlowSingleTemplate
    this.socket = config.sockets ? config.sockets : null
    this.isSequenceAddonAvailable = !! window.xitFlowBuilderData.sequence_addon
    this.isConditionAddonAvailable = !! window.xitFlowBuilderData.messenger_bot_condition
    this.isUserInputFlowAddonAvailable = !! window.xitFlowBuilderData.user_input_flow_addon
    this.isInstagramAddonAvailable = !! window.xitFlowBuilderData.instagram_addon
    this.isRcnAddonAvailable = !! window.xitFlowBuilderData.recurring_notification_addon
    this.is_openai_addon_access = !!window.xitFlowBuilderData.is_openai_addon_access
    this.http_api_module = !! window.xitFlowBuilderData.http_api_module
  }

  builder(node) {
    node.lingualName = lingualName.USER_INPUT_FLOW_SINGLE
    this.setConnection()

    const userInputFlowSingleInput = new Rete.Input(
      CONST_SOCKET.USER_INPUT_FLOW_SINGLE_INPUT, 
      lang.user_input_flow_single_socket_input_reply, 
      this.socket.userInputFlowSingleInput, 
      false
    )

    const userInputFlowSingleOutput = new Rete.Output(
      CONST_SOCKET.USER_INPUT_FLOW_SINGLE_OUTPUT, 
      lang.user_input_flow_single_socket_output_next, 
      this.socket.userInputFlowSingleOutput, 
      false
    )

    const userInputFlowSingleOutputFinalReply = new Rete.Output(
      CONST_SOCKET.USER_INPUT_FLOW_SINGLE_OUTPUT_FINAL_REPLY, 
      lang.user_input_flow_single_socket_output_final_reply, 
      this.socket.userInputFlowSingleOutputFinalReply, 
      false
    )

    return node
      .addInput(userInputFlowSingleInput)
      .addOutput(userInputFlowSingleOutput)
      .addOutput(userInputFlowSingleOutputFinalReply)
  }

  // eslint-disable-next-line
  worker(node, inputs, outputs) {}

  setConnection() {
    this.socket.userInputFlowSingleOutput.combineWith(this.socket.userInputFlowSingleInput)

    this.socket.userInputFlowSingleOutputFinalReply.combineWith(this.socket.textInput)
    if(this.is_openai_addon_access)
      this.socket.userInputFlowSingleOutputFinalReply.combineWith(this.socket.openaiInput)
    this.socket.userInputFlowSingleOutputFinalReply.combineWith(this.socket.carouselInput)
    this.socket.userInputFlowSingleOutputFinalReply.combineWith(this.socket.imageInput)
    
    if (!this.isInstagramAddonAvailable) {
      this.socket.userInputFlowSingleOutputFinalReply.combineWith(this.socket.facebookMediaInput)
      this.socket.userInputFlowSingleOutputFinalReply.combineWith(this.socket.videoInput)
      this.socket.userInputFlowSingleOutputFinalReply.combineWith(this.socket.audioInput)
      this.socket.userInputFlowSingleOutputFinalReply.combineWith(this.socket.fileInput)
      // this.socket.userInputFlowSingleOutputFinalReply.combineWith(this.socket.otnInput)
    }

    if(recurring_notification_display)
      this.socket.userInputFlowSingleOutputFinalReply.combineWith(this.socket.rcnInput)

    this.socket.userInputFlowSingleOutputFinalReply.combineWith(this.socket.ecommerceInput)
    this.socket.userInputFlowSingleOutputFinalReply.combineWith(this.socket.genericTemplateInput)
    this.socket.userInputFlowSingleOutputFinalReply.combineWith(this.socket.componentListInput)

    if(this.http_api_module)
    {
      this.socket.userInputFlowSingleOutputFinalReply.combineWith(this.socket.httpApiInput)
    }

    if (this.isUserInputFlowAddonAvailable) {
      this.socket.userInputFlowSingleOutputFinalReply.combineWith(this.socket.userInputFlowInput)
    }

    // Output: Sequence
    // if (this.isSequenceAddonAvailable) {
    //   this.socket.userInputFlowSingleOutputFinalReplySequence.combineWith(this.socket.sequenceInput)    
    // }
    
    // Output: Condition
    if (this.isConditionAddonAvailable) {  
      this.socket.userInputFlowSingleOutputFinalReply.combineWith(this.socket.conditionInput)
    }
  }
}